// import { WEBSERVER } from './Webserver.js';
// import { PORT } from './Port.js';

import { API } from './API.js';
import axios from 'axios';

// const url = WEBSERVER + ':3000/api/geographies/'
// const url = WEBSERVER + ':' + PORT + '/api/geographies/'

const url = API + '/geographies/'
const debug = false

class Geographies {
    // get geographies
    static get() {
        return new Promise ( async (resolve, reject) => {
            try {
                const res = await axios.get(url);
                const data = res.data;
                resolve(
                    data.map(geography=> ({
                        ...geography,
                        name: geography.name
                    }))
                );
                if (debug) console.log("data = ", data)
            } catch(err) {
                reject(err);
            }

        })
    }

    // get one geography
    static getone(id) {
        return axios.get(`${url}${id}`)
            .then(response => {
                if (debug) console.log('Geographies.getone: ',response.data)
                return response.data
            })
            .catch(error => {
                console.log('Geographies.getone: ',error)
            })
    }

    // create geography
    static create(postdata) {
        return axios.post(url, postdata)
            .then(response => {
                if (debug) console.log('Geographies.create: ',response)
                return response.data._id
            })
            .catch(error => {
                console.log('Geographies.create: ',error)
            })
    }

    static update(id,postdata) {
        if (debug) console.log('Geographies.update: id=',id)
        if (debug) console.log('Geographies.update: postdata=',postdata)
        return axios.put(`${url}${id}`, postdata)
            .then(response => {
                if (debug) console.log('Geographies.update: ',response)
            })
            .catch(error => {
                console.log('Geographies.update: ',error)
            })
    }

    // delete geography
    static delete(id) {
        return axios.delete(`${url}${id}`)
    }
}

export default Geographies